export default __webpack_public_path__ + "static/media/p73.bca2308b.jpg";